import { setupWorker } from "msw";
import jiraHandlers from "./handlers/jira.handlers";

const handlers = [...jiraHandlers];

// This configures a Service Worker with the given request handlers.

export const worker = setupWorker(...handlers);
